import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { DropDownList } from "../Components/DropDownList";
import { UploadPicture } from "../Components/UploadPicture";
import { FormSectionTitle } from "../Components/FormSectionTitle";
import { Typography } from "@mui/material";
import { addEspaceCharacters, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from "../Components/LoaderBox";

const REGLAS_PASSWORD =
  "Mínimo 8 caracteres, con al menos una mayúscula, una minúscula, un número y uno de los siguientes caracteres especiales: !@#$%&_";

function Registro() {
  const [area, setArea] = React.useState({ Id: 0, Nombre: "" });
  const [dialog, setDialog] = React.useState({ title: "", text: "" });
  const [openDialog, setOpenDialog] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(false);
  const [verifyPasswordError, setVerifyPasswordError] = React.useState(false);
  const [puestoTrabajo, setPuestoTrabajo] = React.useState({ Id: 0, Nombre: "" });
  const [localidad, setLocalidad] = React.useState({ Id: 0, Nombre: "" });
  const [genero, setGenero] = React.useState({ Id: 0, Nombre: "" });
  const [renglon, setRenglon] = React.useState({ Id: 0, Nombre: "" });
  const [actividadInv, setActividadInv] = React.useState({ Id: 0, Nombre: "" });

  function validatePassword(password) {
    // Verifica que la cadena tenga un largo mínimo de 8 caracteres
    if (password.length < 8) {
      setErrorText("La contraseña debe tener por lo menos 8 caracteres.");
      return false;
    }

    // Verifica que la cadena contenga por lo menos una letra mayúscula
    if (!/[A-Z]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos una letra minúscula
    if (!/[a-z]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos un número
    if (!/[0-9]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos un caracter especial
    if (!/[!@#$%&_]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // La cadena cumple con todos los requisitos
    setErrorText("");
    return true;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!e.target.upload_image.files[0]) {
      setErrorText("La imagen de perfil es obligatoria.");
      return;
    }
    if (!verifyPassword()) return;
    const info = e.target;
    const formData = new FormData();
    formData.append("correo", addEspaceCharacters(info.email.value));
    formData.append("password", info.password.value);
    formData.append("nombre", addEspaceCharacters(info.nombre.value));
    formData.append("apellido", addEspaceCharacters(info.apellido.value));
    formData.append("area", area.Id); // para mientras se va a seguir usando este valor, pero luego se va a reemplazar por puestoTrabajo
    formData.append("puestoTrabajo", puestoTrabajo.Id);
    formData.append("dpi", addEspaceCharacters(info.dpi.value));
    formData.append("genero", genero.Id);
    formData.append("localidad", localidad.Id);
    formData.append("renglon", renglon.Id);
    formData.append("actividadInv", actividadInv.Id);
    formData.append("profesion", addEspaceCharacters(info.profesion.value));
    formData.append("especialidad", addEspaceCharacters(info.especialidad.value));
    formData.append("foto", info.upload_image.files[0]);
    instance
      .post("/users", formData)
      .then(() => {
        setDialog({
          title: "Registro exitoso",
          text: `Se ha enviado un correo para activar el usuario al correo registrado ${info.email.value}`,
          redirect: true,
          page: "/Login",
        });
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
      })
      .finally(() => setOpenDialog(true));
  };
  const verifyPassword = () => {
    const password = document.querySelector("#password").value;
    const confirmation = document.querySelector("#password_confirmation").value;
    if (password !== confirmation) {
      setErrorText("Error: La contraseña y su confirmación no son iguales.");
      return false;
    } else {
      setErrorText("");
      return true;
    }
  };

  return (
    <LoaderBox>
      <Container
        component="main"
        maxWidth="md"
        className="bordered-box"
        sx={{
          padding: { xs: "8px", sm: "24px" },
          marginTop: 4,
          marginBottom: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5" sx={{ textAlign: "center" }}>
          Registro
        </Typography>
        <Grid
          component="form"
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          onSubmit={handleSubmit}
          sx={{ width: "100%" }}
        >
          <Grid item xs={12} sm={12} sx={{ display: "flex", justifyContent: "center", marginTop: 1 }}>
            <UploadPicture />
          </Grid>

          <FormSectionTitle>Datos personales</FormSectionTitle>

          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="nombre"
              label="Nombre(s)"
              name="nombre"
              inputProps={{ maxLength: 50 }}
              autoFocus
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="apellido"
              label="Apellido(s)"
              name="apellido"
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type="email"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Correo electrónico"
              name="email"
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="dpi"
              label="DPI"
              name="dpi"
              inputProps={{ maxLength: 13 }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            <DropDownList
              required
              title="Género"
              endpoint={"/genero" }
              selectedItem={genero}
              setSelectedItem={setGenero}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            <DropDownList
              required
              title="Localidad"
              endpoint={"/localidad/listLocalidades" }
              selectedItem={localidad}
              setSelectedItem={setLocalidad}
            />
          </Grid>

          <FormSectionTitle>Información laboral</FormSectionTitle>

          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <DropDownList
              required
              title="Área"
              endpoint={"/area"}
              selectedItem={area}
              setSelectedItem={setArea}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            <DropDownList
              required
              title="Puesto de trabajo"
              endpoint={area.Id ? `/puestoTrabajo/listPuestos/${area.Id}`: undefined }
              selectedItem={puestoTrabajo}
              setSelectedItem={setPuestoTrabajo}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            <DropDownList
              required
              title="Renglón presupuestario"
              endpoint={"/renglon" }
              selectedItem={renglon}
              setSelectedItem={setRenglon}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            <DropDownList
              required
              title="Actividad de investigación"
              endpoint={"/actividadInvestigacion" }
              selectedItem={actividadInv}
              setSelectedItem={setActividadInv}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="profesion"
              label="Profesión/oficio"
              name="profesion"
              inputProps={{ maxLength: 60 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              fullWidth
              id="especialidad"
              label="Especialidad"
              name="especialidad"
              inputProps={{ maxLength: 60 }}
            />
          </Grid>

          <FormSectionTitle>Seguridad</FormSectionTitle>

          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              onChange={(e) => {
                setPasswordError(!validatePassword(e.target.value));
              }}
              error={passwordError}
              helperText={REGLAS_PASSWORD}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="password_confirmation"
              label="Confirmar contraseña"
              type="password"
              id="password_confirmation"
              onChange={() => setVerifyPasswordError(!verifyPassword())}
              error={verifyPasswordError}
            />
          </Grid>

          {errorText && (
            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", marginTop: 1 }}>
              <Typography component="p" variant="body2" color="error">
                {errorText}
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} sm={12} sx={{ marginTop: 2 }}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 1, mb: 2 }}
            >
              Registrar
            </Button>
          </Grid>
        </Grid>
        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
          redirectOnClose={dialog.redirect}
          page={dialog.page}
          pageState={dialog.pageState}
        />
      </Container>
    </LoaderBox>
  );
}

export { Registro };
